import _ from 'lodash';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const getId = (pubmedData, idType) => {
  if (pubmedData) {
    let id = _.find(pubmedData.articleids, { idtype: idType });
    return _.get(id, 'value');
  } else {
    return null;
  }
};

export default data =>
  data?.pubmed_data
    ? {
        pmid: getId(data.pubmed_data, 'pubmed'),
        journal:
          _.get(data, 'details.journal') ||
          _.get(data, 'pubmed_data.fulljournalname'),
        journal_link: {
          title:
            _.get(data, 'details.journal_link.title') ||
            `DOI: ${getId(data.pubmed_data, 'doi')}`,
          href:
            _.get(data, 'details.journal_link.href') ||
            (getId(data.pubmed_data, 'doi')
              ? `https://doi.org/${getId(data.pubmed_data, 'doi')}`
              : '')
        },
        publish_date:
          _.get(data, 'details.publish_date') ||
          dayjs.utc(data.pubmed_data.pubdate).format(),
        title: _.get(data, 'details.title') || _.get(data, 'pubmed_data.title'),
        first_author:
          _.get(data, 'details.first_author') ||
          _.get(data, 'pubmed_data.sortfirstauthor'),
        authors:
          (_.get(data, 'details.authors')
            ? _.get(data, 'details.authors').split('; ')
            : false) ||
          (data.pubmed_data.authors && data.pubmed_data.authors.length
            ? data.pubmed_data.authors.map(author => author.name)
            : []),
        affiliations:
          _.get(data, 'details.affiliations', []).length > 0
            ? _.get(data, 'details.affiliations', [])
            : _.get(data, 'pubmed_data.affiliations'),
        abstract:
          _.get(data, 'details.abstract') || _.get(data, 'pubmed_data.abstract')
      }
    : null;
